import { useState, useEffect } from 'react';
import apiClient from '../services/axiosInterceptor';

export interface TimetableTypeOption {
  label: string;
  value: string;
  id: string;
}

interface TimetableTypeResponse {
  id: number;
  name: string;
  session: string;
}

interface TimetableTypesApiResponse {
  status: 'success' | 'error';
  data: TimetableTypeResponse[];
  message?: string;
}

const useTimetableTypes = (includePlaceholder: boolean = false) => {
  const [options, setOptions] = useState<TimetableTypeOption[]>([]);

  useEffect(() => {
    const fetchTimetableTypes = async () => {
      try {
        const response = await apiClient.get<TimetableTypesApiResponse>('timetable-types');

        if (response.data.status === 'success') {
          if (response.data.data.length === 0) {
            if (includePlaceholder) {
              setOptions([{ label: 'No timetable types available', value: '', id: '' }]);
            } else {
              setOptions([]);
            }
          } else {
            const mapped = response.data.data
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item) => ({
                label: item.name,
                value: item.name,
                id: item.id.toString(),
              }));

            if (includePlaceholder) {
              setOptions([
                { label: 'Select a Timetable Type', value: '', id: '' },
                ...mapped,
              ]);
            } else {
              setOptions(mapped);
            }
          }
        } else if (response.data.message === 'empty') {
          if (includePlaceholder) {
            setOptions([{ label: 'No timetable types available', value: '', id: '' }]);
          } else {
            setOptions([]);
          }
        }
      } catch (error) {
        console.error('Error fetching timetable types:', error);
        // Auth errors (401) are handled by your interceptor
      }
    };

    fetchTimetableTypes();
  }, [includePlaceholder]);

  return options;
};

export default useTimetableTypes;